<div class="admin-container">
  <h2>Article link</h2>
  <form class="form">
    <p-select
      [options]="articles | async"
      [(ngModel)]="sectionData.articleId"
      optionValue="id"
      optionLabel="name"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      name="articleId"
    >
    </p-select>
  </form>
</div>
